import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { createStructuredSelector } from "reselect";
import CustomButton from "../../components/form-inputs/custom-button.component";
import { selectReportsForPreview } from "../../redux/reports/report.selector";
import { selectGemeinde } from "../../redux/gemeinde/gemeinde.selector";
import { fetchReportsStart } from "../../redux/reports/report.actions";
import ReportOverviewComponent from "../../components/report/report-overview.component";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    margin: "20px",
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    alignContent: "flex-start",
  },
});

const ReportsPage = ({ berichte, history, gemeinde, fetchReportsStart }) => {
  const classes = useStyles();
  useEffect(() => {
    console.log("Effect");
    fetchReportsStart();
  }, [gemeinde, fetchReportsStart]);

  const eigeneBerichte = gemeinde
    ? berichte.filter((b) => b.gemeindeId === gemeinde.id)
    : [];
  const andereBerichte = gemeinde
    ? berichte.filter((b) => b.gemeindeId !== gemeinde.id)
    : berichte;
  const berichteInBewertung = andereBerichte.filter(
    (b) => b.bewertungsende.seconds * 1000 > Date.now()
  );
  const abgeschlosseneBerichte = andereBerichte.filter(
    (b) => b.bewertungsende.seconds * 1000 < Date.now()
  );

  return (
    <div className={classes.root}>
      <PageHeaderComponent title="Berichte" subtitle="Was bisher geschah..." />
      {eigeneBerichte && eigeneBerichte.length > 0 ? (
        <>
          <Typography variant="h4">Eigene Berichte:</Typography>
          <div className={classes.list}>
            {eigeneBerichte.map((bericht) => (
              <ReportOverviewComponent key={bericht.id} bericht={bericht} />
            ))}
          </div>
        </>
      ) : null}
      {berichteInBewertung && berichteInBewertung.length > 0 ? (
        <>
          <Typography variant="h4">Berichte in Bewertung:</Typography>
          <div className={classes.list}>
            {berichteInBewertung.map((bericht) => (
              <ReportOverviewComponent key={bericht.id} bericht={bericht} />
            ))}
          </div>
        </>
      ) : null}
      {abgeschlosseneBerichte && abgeschlosseneBerichte.length > 0 ? (
        <>
          <Typography variant="h4">Bewertete Berichte:</Typography>
          <div className={classes.list}>
            {abgeschlosseneBerichte.map((bericht) => (
              <ReportOverviewComponent key={bericht.id} bericht={bericht} />
            ))}
          </div>
        </>
      ) : null}
      <div>
        {gemeinde ? (
          <CustomButton
            onClick={() => {
              history.push("/bericht-edit/new");
            }}
          >
            Neuen Bericht einreichen
          </CustomButton>
        ) : null}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchReportsStart: () => dispatch(fetchReportsStart()),
});
const mapStateToProps = createStructuredSelector({
  gemeinde: selectGemeinde,
  berichte: selectReportsForPreview,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportsPage)
);
